<div class="content-card">
    <div class="filter-controls">
      <mat-checkbox
        [checked]="hideInactive"
        (change)="onIncludeInactiveChange($event)"
        color="primary">
        {{ registerPrefix + '.HideInactive' | translate }}
      </mat-checkbox>
    </div>

    <div class="table-wrapper custom-table">
      <mat-table
        #table
        matSort
        [matSortActive]="defaultSortColumn"
        matSortDirection="desc"
        matSortDisableClear
        [dataSource]="dataSource.documents$ | async"
        multiTemplateDataRows
        class="main-table"
      >
        <!-- Expand Column -->
        <ng-container matColumnDef="expandingIcon">
          <mat-header-cell *matHeaderCellDef class="expand-header"></mat-header-cell>
          <mat-cell [class.clickable]="element[expansionDataName]?.length > 0" 
              class="expand-cell clickable" *matCellDef="let element" (click)="element[expansionDataName]?.length > 0 && expandRow(expandedElementDocumentId, element.Id)">
            <mat-icon *ngIf="element[expansionDataName]?.length > 0">
              {{ expandedElementDocumentId !== element.Id ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
            </mat-icon>
          </mat-cell>
        </ng-container>
        <!-- LastName Column -->
        <ng-container matColumnDef="lastName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ registerPrefix + '.LastName' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.LastName }}
          </mat-cell>
        </ng-container>
        <!-- FirstName Column -->
        <ng-container matColumnDef="firstName">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ registerPrefix + '.FirstName' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">
            {{ element.FirstName }}
          </mat-cell>
        </ng-container>
        <!-- Document Column -->
        <ng-container matColumnDef="document">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ registerPrefix + '.DocumentType' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.Document }}</mat-cell>
        </ng-container>
        <!-- DocumentStartDate	- DocumentEndDate Column -->
        <ng-container matColumnDef="documentStartDate">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ registerPrefix + '.DocumentValidationDate' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.DocumentStartDate | date : 'dd.MM.yyyy' }} - {{ element.DocumentEndDate | date : 'dd.MM.yyyy' }}</mat-cell>
        </ng-container>
        <!-- DocumentCategoryName Column -->
        <ng-container matColumnDef="documentCategoryName">
          <mat-header-cell *matHeaderCellDef> {{ registerPrefix + '.DocumentCategoryName' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.DocumentCategory }}</mat-cell>
        </ng-container>
        <!-- DocumentStatus Column -->
        <ng-container matColumnDef="documentStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ registerPrefix + '.DocumentStatusName' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.DocumentStatus }}</mat-cell>
        </ng-container>
        <!-- Alert Column -->
        <ng-container matColumnDef="alert">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ registerPrefix + '.Alert' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.Alert }}</mat-cell> 
        </ng-container>
         <!-- legalizationStatus Column -->
         <ng-container matColumnDef="legalizationStatus">
          <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
            {{ registerPrefix + '.StatusName' | translate }}
            <app-table-header-sort></app-table-header-sort>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">{{ element.LegalizationStatus }}</mat-cell> 
        </ng-container>
        <!-- StatusJustification Column -->
         <!-- TODO: Add when we implement it -->
         <ng-container matColumnDef="statusJustification">
          <mat-header-cell *matHeaderCellDef class="hidden-sort">
            {{ registerPrefix + '.StatusJustification' | translate }}
          </mat-header-cell>
          <mat-cell *matCellDef="let element"></mat-cell> 
        </ng-container>
  
        <!-- Actions Column -->
        <ng-container matColumnDef="actions" stickyEnd>
          <mat-header-cell *matHeaderCellDef>{{ 'DeclarationsList.Actions' | translate }}</mat-header-cell>
          <mat-cell *matCellDef="let element">
            <ng-container> </ng-container>
            <ng-container *ngIf="screenService.isAboveMd$ | async; else iconButton">
              <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            </ng-container>
  
            <ng-template #iconButton>
              <button mat-icon-button [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            </ng-template>
            <mat-menu #menuRow="matMenu" panelClass="actions-menu">
              <ng-container>
                <button mat-button (click)="openLegalizationFilesModal(element.Files, element.WorkerId, element.Document)">
                  <mat-icon class="material-icons-outlined">folder_open</mat-icon>
                  <span class="button-text">{{ registerPrefix + '.ShowFiles' | translate }}</span>
                </button>
              </ng-container>
              <ng-container>
                <button [visibleWithPermissions]="['AddLegalizationDocument']" mat-button (click)="openDocumentLegalizationForCoordinator(element.WorkerId)">
                  <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                  <span class="button-text">{{ registerPrefix + '.AddDocument' | translate }}</span>
                </button>
              </ng-container>
              <ng-container>
                <button [visibleWithPermissions]="['LegalizationDecision']" mat-button (click)="openDocumentLegalizationForLegalizer(element.WorkerId, element.LegalizationId, element.DocumentStatusId, element.Id)">
                  <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                  <span class="button-text">{{ addOrCorrectLabel(element) }}</span>
                </button>
              </ng-container>
              <ng-container>
                <button [visibleWithPermissions]="['EditLegalizationDocument']" mat-button (click)="editDocument(element.Id)">
                  <mat-icon class="material-icons-outlined">edit</mat-icon>
                  <span class="button-text">{{ registerPrefix + '.EditDocument' | translate }}</span>
                </button>
              </ng-container>
              <ng-container>
                <button
                  mat-button               
                  [routerLink]="['/profile/' + element.WorkerId + '/documents']"
                >
                  <mat-icon class="material-icons-outlined">person</mat-icon>
                  <span class="button-text">{{ registerPrefix + '.ShowWorkerProfile' | translate }}</span>
                </button>
              </ng-container>
            </mat-menu>
          </mat-cell>
        </ng-container>
  
        <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
        <ng-container matColumnDef="expandedDetail">
          <mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div class="expanded-element-detail" [@detailExpand]="element.Id == expandedElementDocumentId ? 'expanded' : 'collapsed'">
              <mat-table #table [dataSource]="element[expansionDataName]" class="secondary-table">
                <!-- Add empty column to align with expand arrow -->
                <ng-container matColumnDef="expandingIconSpace">
                  <mat-header-cell *matHeaderCellDef class="expand-header"></mat-header-cell>
                  <mat-cell class="expand-cell" *matCellDef="let element"></mat-cell>
                </ng-container>
                <!-- LastName Column -->
                <ng-container matColumnDef="lastName">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.LastName' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.LastName }}
                  </mat-cell>
                </ng-container>
                <!-- FirstName Column -->
                <ng-container matColumnDef="firstName">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.FirstName' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    {{ element.FirstName }}
                  </mat-cell>
                </ng-container>
                <!-- Document Column -->
                <ng-container matColumnDef="document">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.DocumentType' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.Document }}</mat-cell>
                </ng-container>
                <!-- DocumentStartDate	- DocumentEndDate Column -->
                <ng-container matColumnDef="documentStartDate">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.DocumentValidationDate' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.DocumentStartDate | date : 'dd.MM.yyyy' }} - {{ element.DocumentEndDate | date : 'dd.MM.yyyy' }}</mat-cell>
                </ng-container>
                <!-- DocumentCategoryName Column -->
                <ng-container matColumnDef="documentCategoryName">
                  <mat-header-cell *matHeaderCellDef> {{ registerPrefix + '.DocumentCategoryName' | translate }} </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.DocumentCategory }}</mat-cell>
                </ng-container>
                <!-- DocumentStatus Column -->
                <ng-container matColumnDef="documentStatus">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.DocumentStatusName' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.DocumentStatus }}</mat-cell>
                </ng-container>
                <!-- Alert Column -->
                <ng-container matColumnDef="alert">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.Alert' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"></mat-cell> 
                </ng-container>
                <!-- legalizationStatus Column -->
                <ng-container matColumnDef="legalizationStatus">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.StatusName' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element">{{ element.LegalizationStatus }}</mat-cell> 
                </ng-container>
                <!-- StatusJustification Column -->
                <!-- TODO: Add when we implement it -->
                <ng-container matColumnDef="statusJustification">
                  <mat-header-cell *matHeaderCellDef class="hidden-sort">
                    {{ registerPrefix + '.StatusJustification' | translate }}
                  </mat-header-cell>
                  <mat-cell *matCellDef="let element"></mat-cell> 
                </ng-container>
                <!-- Actions Column -->
                <ng-container matColumnDef="actions" stickyEnd>
                  <mat-header-cell *matHeaderCellDef>{{ 'DeclarationsList.Actions' | translate }}</mat-header-cell>
                  <mat-cell *matCellDef="let element">
                    <ng-container> </ng-container>
                    <ng-container *ngIf="screenService.isAboveMd$ | async; else iconButton">
                      <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                      </button>
                    </ng-container>
  
                    <ng-template #iconButton>
                      <button mat-icon-button [matMenuTriggerFor]="menuRow">
                        <mat-icon class="material-icons-outlined">more_vert</mat-icon>
                      </button>
                    </ng-template>
                    <mat-menu #menuRow="matMenu" panelClass="actions-menu">
                      <ng-container>
                        <button mat-button (click)="openLegalizationFilesModal(element.Files, element.WorkerId, element.Document)">
                          <mat-icon class="material-icons-outlined">folder_open</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.ShowFiles' | translate }}</span>
                        </button>
                      </ng-container>
                      <ng-container>
                        <button [visibleWithPermissions]="['AddLegalizationDocument']" mat-button (click)="openDocumentLegalizationForCoordinator(element.WorkerId)">
                          <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.AddDocument' | translate }}</span>
                        </button>
                      </ng-container>
                      <ng-container>
                        <button [visibleWithPermissions]="['LegalizationDecision']" mat-button (click)="openDocumentLegalizationForLegalizer(element.WorkerId, expandedElementDocumentId, null, null)">
                          <mat-icon class="material-icons-outlined">add_circle</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.AddDocument' | translate }}</span>
                        </button>
                      </ng-container>
                      <ng-container>
                        <button
                          mat-button               
                          [routerLink]="['/profile/' + element.WorkerId + '/documents']"
                        >
                          <mat-icon class="material-icons-outlined">person</mat-icon>
                          <span class="button-text">{{ registerPrefix + '.ShowWorkerProfile' | translate }}</span>
                        </button>
                      </ng-container>
                    </mat-menu>
                  </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let row; columns: displayedExpandedColumns"></mat-row>
              </mat-table>
            </div>
          </mat-cell>
        </ng-container>
  
        <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
        <mat-row
          *matRowDef="let element; columns: displayedColumns"
          class="expanded-element-row"
          [class.expanded-expanded-row]="expandedElementDocumentId === element.Id"
        ></mat-row>
        <mat-row
          [@rowExpand]="row.Id == expandedElementDocumentId ? 'expanded' : 'collapsed'"
          *matRowDef="let row; columns: ['expandedDetail']"
          class="expanded-detail-row"
        ></mat-row>
      </mat-table>
      <mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"> </mat-paginator>
    </div>
  </div>  